// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__sHKKU","close":"Popup_close__4vADF"};